import { Loader } from "@mantine/core";
import { Pagination } from "@mantine/core";
import { useState } from "react";
import { useEffect, useCallback } from "react";
import { useRef } from "react";
import { useRouter } from "next/router";
import CampaignsCarouselMobile from "./homepage/CampaignsCarouselMobile";
import useAllCampaigns from "../hooks/useAllCampaigns";
import useAllCampaignsGraph from "../hooks/useAllCampaignsGraph";
import { AirdropGridItem } from "./AirdropGridItem";
import { CampaignGridItem } from "./CampaignGridItem";
import useRequest from "@/hooks/useRequest";

export default function AllAirdropsGrid({ pageNum, type }) {
  const router = useRouter();
  const filterItems = ["NFT", "TOKEN", "Form"];
  const [buttonSelect, setButtonSelect] = useState(
    type === "ALL" ? "ALL" : type
  );

  const { data: featuredCampaigns, isLoading: featuredCampaignsLoading } =
    useRequest({
      function: "campaign/get_featured_campaigns",
      data: {},
    });

  const { data: allCampaigns, isLoading: allCampaignsLoading } = useRequest({
    function: "campaign/get_all_campaigns",
    data: {},
  });

  const campaignLoading = featuredCampaignsLoading || allCampaignsLoading;

  const campaigns = allCampaigns || [];

  const recentCampaigns = campaigns.slice(0, 12);

  const featuresCampaigns = featuredCampaigns || [];

  const ALLCampaigns = campaigns;

  const NFTCampaigns = campaigns?.filter((campaign) => campaign.type === "NFT");
  const TokenCampaigns = campaigns?.filter(
    (campaign) => campaign.type === "TOKEN"
  );
  const FormCampaigns = campaigns?.filter(
    (campaign) => campaign.type === "FORM"
  );
  const nftRef = useRef(null);
  const [activePage, setActivePage] = useState(Number(pageNum));
  const [pageCountAll, setPageCountAll] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountToken, setPageCountToken] = useState(0);

  const setSearchParams = useCallback(
    (query) => {
      let changed = false;
      for (let prop in query) {
        if (String(query[prop]) !== String(router.query[prop])) {
          changed = true;
          break;
        }
      }
      if (changed) {
        router.push(
          {
            pathname: router.pathname,
            query,
          },
          undefined,
          {
            scroll: false,
          }
        );
      }
    },
    [router]
  );

  const onChangePage = useCallback(
    (page) => {
      setSearchParams({
        page,
        type,
      });
    },
    [setSearchParams, type]
  );
  const itemsPerPage = 10;
  const itemsVisited = (activePage - 1) * itemsPerPage;

  const ALLdisplay =
    ALLCampaigns?.map((item, index) => {
      if (item.type === "FORM") {
        return (
          <CampaignGridItem key={index} campaign={item}></CampaignGridItem>
        );
      }
      return <AirdropGridItem key={index} campaign={item} feature={false} />;
    }) ?? [];
  const NFTdisplay =
    NFTCampaigns?.map((item, index) => {
      return <AirdropGridItem key={index} campaign={item} feature={false} />;
    }) ?? [];
  const TOKENdisplay = TokenCampaigns?.map((item, index) => {
    return <AirdropGridItem key={index} campaign={item} feature={false} />;
  });
  const FormDisplay = FormCampaigns?.map((item, index) => {
    return <CampaignGridItem key={index} campaign={item} />;
  });
  // console.log(featuresCampaigns);
  const FeaturesDisplay = featuresCampaigns?.map((item, index) => {
    if (item.type === "FORM") {
      return <CampaignGridItem key={index} campaign={item} feature={true} />;
    } else {
      return <AirdropGridItem key={index} campaign={item} feature={true} />;
    }
  });
  useEffect(() => {
    // setDisplayCampaign(type === 'NFT' ? NFTdisplay : TOKENdisplay);
    // console.log(NFTdisplay, TOKENdisplay);
    setPageCountAll(Math.ceil(ALLCampaigns.length / itemsPerPage));
    setPageCount(Math.ceil(NFTCampaigns.length / itemsPerPage));
    setPageCountToken(Math.ceil(TokenCampaigns.length / itemsPerPage));
    // eslint-disable-next-line
  }, [ALLCampaigns, NFTCampaigns, TokenCampaigns]);

  const displayCampaign = (
    type === "ALL"
      ? ALLdisplay
      : type === "NFT"
      ? NFTdisplay
      : type === "TOKEN"
      ? TOKENdisplay
      : FormDisplay
  ).slice(itemsVisited, itemsVisited + itemsPerPage);
  useEffect(() => {
    nftRef.current.scrollIntoView({ behavior: "smooth" });
  }, [activePage]);
  // useEffect(() => {
  //   setDisplayCampaign(type === 'NFT' ? NFTdisplay : TOKENdisplay);
  //   //eslint-disable-next-line
  // }, []);
  useEffect(() => {
    setButtonSelect(type);
    setActivePage(Number(pageNum));
  }, [type, pageNum]);
  return (
    <div className="flex flex-col">
      <h1 className="mx-auto mb-8 flex flex-row text-4xl font-bold sm:mb-14">
        Featured airdrops
      </h1>
      <div className="flex justify-center sm:hidden">
        <CampaignsCarouselMobile
          recentCampaigns={recentCampaigns}
          campaignLoading={campaignLoading}
          feature={true}
        />
      </div>
      <div className="mb-[66px] hidden flex-col justify-between sm:flex">
        {/* {campaigns?.map((item, index) => (
              <AirdropGridItem key={index} campaign={item} />
            ))} */}
        {campaignLoading ? (
          <div className="flex justify-center">
            <Loader color={"#ADB5FF"} />
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-3  md:grid-cols-4 lg:grid-cols-4">
            {FeaturesDisplay}
          </div>
        )}
      </div>
      <div className="flex h-6 flex-row justify-between">
        <h1
          ref={nftRef}
          className=" flex flex-row text-body sm:text-lg font-bold "
        >
          All Campaigns
        </h1>
        <div className=" text-md flex flex-row items-center  justify-center">
          <div className="mr-4 flex  flex-row"> Filter </div>
          {filterItems.map((item, index) => {
            return (
              <button
                key={index}
                className={
                  buttonSelect === item
                    ? "btn-pri-base mr-2  px-2 py-1 text-white"
                    : "btn-sec-base mr-2  px-2 py-1 text-dark1"
                }
                onClick={() => {
                  if (item === type) {
                    setSearchParams({
                      type: "ALL",
                      page: 1,
                    });
                  } else {
                    setSearchParams({
                      type: item,
                      page: 1,
                    });
                  }
                }}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>

      {campaignLoading ? (
        <div className="mt-6 flex justify-center">
          <Loader color={"#ADB5FF"} />
        </div>
      ) : (
        <div className="mt-6">
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5">
            {/* {campaigns?.map((item, index) => (
              <AirdropGridItem key={index} campaign={item} />
            ))} */}
            {displayCampaign}
          </div>
          <Pagination
            className="flex justify-center py-10 "
            styles={{
              active: {
                color: "#adb5ff",
                border: "none",
                backgroundColor: "transparent",
              },
            }}
            value={activePage}
            onChange={onChangePage}
            total={
              type === "NFT"
                ? pageCount
                : type === "ALL"
                ? pageCountAll
                : pageCountToken
            }
          />
        </div>
      )}
    </div>
  );
}
